import React from "react";
import { useTranslation } from "react-i18next";

function Terms() {
  const { t } = useTranslation('terms');
  
  return (
    <section className="terms-section section-padding">
      <div className="container">
        <h2 className="mb-4">{t('title')}</h2>

        {/* Privacy Policy Section */}
        <div className="mb-5">
          <h4 className="mb-3">{t('privacy.title')}</h4>
          <p className="mb-3">{t('privacy.introduction')}</p>
          <p className="mb-3">{t('privacy.company')}</p>
        </div>

        {/* Cookies Section */}
        <div className="mb-5">
          <h4 className="mb-3">{t('privacy.cookies.title')}</h4>
          <p className="mb-3">{t('privacy.cookies.content')}</p>
          <p className="mb-2"><strong>{t('privacy.cookies.whatAreCookies')}</strong></p>
          <p className="mb-2">{t('privacy.cookies.types')}</p>
          <p className="mb-2">{t('privacy.cookies.dataCollection')}</p>
          <p className="mb-2">{t('privacy.cookies.usage')}</p>
          <p className="mb-2">{t('privacy.cookies.anonymity')}</p>
          <p className="mb-2">{t('privacy.cookies.retention')}</p>
          <p className="mb-2">{t('privacy.cookies.settings')}</p>
          <p className="mb-3">{t('privacy.cookies.moreInfo')}</p>
        </div>

        {/* Data Collection Section */}
        <div className="mb-5">
          <h4 className="mb-3">{t('privacy.dataCollection.title')}</h4>
          <p className="mb-2">{t('privacy.dataCollection.content')}</p>
          <p className="mb-2"><strong>{t('privacy.dataCollection.minimal')}</strong></p>
          <p className="mb-2">{t('privacy.dataCollection.storage')}</p>
          <p className="mb-3">{t('privacy.dataCollection.marketing')}</p>
        </div>

        {/* Rights Section */}
        <div className="mb-5">
          <h4 className="mb-3">{t('privacy.rights.title')}</h4>
          <p className="mb-2">{t('privacy.rights.content')}</p>
          <ul>
            <li>{t('privacy.rights.access')}</li>
            <li>{t('privacy.rights.correction')}</li>
            <li>{t('privacy.rights.deletion')}</li>
            <li>{t('privacy.rights.objection')}</li>
            <li>{t('privacy.rights.withdrawal')}</li>
            <li>{t('privacy.rights.complaint')}</li>
          </ul>
        </div>

        {/* Security Section */}
        <div className="mb-5">
          <h4 className="mb-3">{t('privacy.security.title')}</h4>
          <p>{t('privacy.security.content')}</p>
        </div>

        {/* Privacy Contact Section */}
        <div className="mb-5">
          <h4 className="mb-3">{t('privacy.contact.title')}</h4>
          <p>{t('privacy.contact.content')}</p>
        </div>

        {/* Privacy Changes Section */}
        <div className="mb-5">
          <h4 className="mb-3">{t('privacy.changes.title')}</h4>
          <p>{t('privacy.changes.content')}</p>
        </div>

        {/* General Terms Section */}
        <div className="mb-5">
          <h4 className="mb-3">{t('general.title')}</h4>
          <p className="mb-2">{t('general.company')}</p>
          <ul>
            <li><strong>{t('general.vat')}</strong></li>
            <li><strong>{t('general.registration')}</strong></li>
            <li><strong>{t('general.services')}</strong></li>
            <li><strong>{t('general.restrictions')}</strong></li>
            <li><strong>{t('general.law')}</strong></li>
            <li><strong>{t('general.changes')}</strong></li>
          </ul>
        </div>

        {/* Website Usage Section */}
        <div className="mb-5">
          <h4 className="mb-3">{t('website.title')}</h4>
          <p className="mb-2">{t('website.content')}</p>
          <ul>
            <li><strong>{t('website.information')}</strong></li>
            <li><strong>{t('website.images')}</strong></li>
            <li><strong>{t('website.responsibility')}</strong></li>
          </ul>
        </div>

        {/* Contacts Section */}
        <div className="mb-5">
          <h4 className="mb-3">{t('contacts.title')}</h4>
          <p><strong>{t('contacts.address')}</strong></p>
          <p><strong>{t('contacts.email')}</strong></p>
          <p><strong>{t('contacts.website')}</strong></p>
          <p><strong>{t('contacts.contactPage')}</strong></p>
        </div>
      </div>
    </section>
  );
}

export default Terms;
